/* unplugin-vue-components disabled */import script from "./menu-manage.vue?vue&type=script&setup=true&lang=js"
export * from "./menu-manage.vue?vue&type=script&setup=true&lang=js"

import "./menu-manage.vue?vue&type=style&index=0&id=1b57964f&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b57964f"]])

export default __exports__